import { useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useOverlayContext } from 'seagull';
import { routes } from "../constants";
import { useIoContext, useStoreActions, useStoreStatic } from "../contexts";
import { handlePromise } from "../infra/utils";
import { useHomePage } from "../pages/HomePage/HomePageProvider";
import { selectors } from "../store/state-selectors";
const loaderName = 'switch-business';
export const prevBusinessIdKey = 'prevBusinessId';
export function useSwitchBusiness() {
  const history = useHistory();
  const {
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  const {
    getState
  } = useStoreStatic();
  const {
    api,
    setAuthToken,
    resetBusinessData,
    logBI
  } = useStoreActions();
  const {
    localStorage
  } = useIoContext();
  const {
    setHidden
  } = useHomePage();
  function getPrevBusinessId() {
    return localStorage.getItem(prevBusinessIdKey);
  }
  async function switchBusiness(businessId) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const showFailureToast = () => showErrorToast('Failed to switch business', 'switch-business-failure');
    if (!businessId) {
      showFailureToast();
      history.push(routes.logout);
      return;
    }
    const prevBusinessId = selectors.user.businessId(getState());
    startLoader(loaderName);
    const authToken = await handlePromise(api.user.switchBusiness(businessId));
    logBI(10354);
    if (authToken.data) {
      setHidden(true);
      prevBusinessId && localStorage.setItem(prevBusinessIdKey, prevBusinessId);
      resetBusinessData();
      Sentry.addBreadcrumb({
        type: 'switchBusiness',
        data: {
          businessId,
          prevBusinessId
        }
      });
      try {
        await setAuthToken(authToken.data);
        history.push(options.newRoute || routes.home);
      } catch (e) {
        showFailureToast();
        history.push(routes.logout);
      }
      setHidden(false);
    }
    stopLoader(loaderName);
  }
  return {
    switchBusiness,
    getPrevBusinessId
  };
}